
import React from "react";
import {  useSelector } from "react-redux";
import { AppState } from "../config/redux/reducers";
import AppConstants from "../constants";
import UACConstants from "../constants/UACConstants";
import {
  createGetAllPlannedRoutesPayload,
  createUpdateOrderStatusPayload,
  getAllAreasAndSlots,
  getDiscardRoutePayload,
  transformRouteConsignments,
  getRouteStatusField,
  getConsignmentStatusField,
  checkTerminalStatus,
} from "../mocks/valetTrolley/response.transforms";
import {getAddressInfo, getConsignmentData, createDraftRoutePayload, createRouteCreationPayload, getTotalCrates, calculateTransitTime, createGetAllDropdownsPayload} from '../mocks/SharedTransform/response.transforms';
import {
  createDraftRoute,
  createAndEditRoute,
  fetchAllDrivers,
  fetchAllHelpers,
  fetchAllVehicles,
  fetchAllPlannedRoutes,
  updateConsignmentStatus,
  discardRouteChanges,
  resetPlanningError,
  updateAllConsignmentsState,
  loadAllSlots,
  clearCurrentSlot,
  fetchRouteConsignments,
  clearUpdatedRoute,
} from "./redux/valetTrolleySlice";
import { userLogout } from "../Login/redux/loginSlice";

import ValetTrolleyOrderDetails from "./ValetTrolleyOrderDetails";
import CreateRouteCommon from "SharedComponent/components/createRoute";

interface CreateRouteProps {
  location?: any;
  match?: any;
  editMode?: boolean;
  viewMode?: boolean;
}

const CreateRoute = (props: CreateRouteProps) => {

  const { editMode, viewMode, match, location } = props;
  const {
    loading,
    draftRoute,
    areawiseConsignments,
    slotwiseConsignments,
    allConsignments,
    routeConsignments,
    slotwisePlannedRoutes,
    driversList,
    helpersList,
    vehiclesList,
    vehiclesData,
    routeCreateSuccess,
    updatedRoute,
    routeDiscardSuccess,
    currentSlot,
    slotsList,
    consignmentStatusList,
    error,
    errorCode,
  } = useSelector((state: AppState) => state.valetTrolley);

 
   return (
      <CreateRouteCommon
        OrderDetailsComponent={ValetTrolleyOrderDetails}
        deliveryState={{
          loading,
          draftRoute,
          areawiseConsignments,
          slotwiseConsignments,
          allConsignments,
          routeConsignments,
          slotwisePlannedRoutes,
          driversList,
          helpersList,
          vehiclesList,
          vehiclesData,
          routeCreateSuccess,
          updatedRoute,
          routeDiscardSuccess,
          currentSlot,
          slotsList,
          consignmentStatusList,
          error,
          errorCode,
        }}
        actions={{
          createDraftRoute,
          createAndEditRoute,
          fetchAllDrivers,
          fetchAllHelpers,
          fetchAllVehicles,
          fetchAllPlannedRoutes,
          updateConsignmentStatus,
          discardRouteChanges,
          resetPlanningError,
          updateAllConsignmentsState,
          loadAllSlots,
          clearCurrentSlot,
          fetchRouteConsignments,
          clearUpdatedRoute,
          userLogout,
        }}
        transforms={{
          calculateTransitTime,
          createDraftRoutePayload,
          createGetAllDropdownsPayload,
          createGetAllPlannedRoutesPayload,
          createRouteCreationPayload,
          createUpdateOrderStatusPayload,
          getAllAreasAndSlots,
          getConsignmentData,
          getDiscardRoutePayload,
          getTotalCrates,
          transformRouteConsignments,
          getAddressInfo,
          getRouteStatusField,
          getConsignmentStatusField,
          checkTerminalStatus,
        }}
        editMode={editMode}
        viewMode={viewMode}
        match={match}
        location={location}
        editRoutePath={AppConstants.ROUTES.VALET_TROLLEY_EDIT_ROUTE}
        componentName="svt"
        uacKey={UACConstants.VT_ROUTES}
      />
    );
};

export default CreateRoute;
